const equipmenttypes = {
	title: "Equipment Types",
	stitle: "Equipment Type",
	new_title: "New Equipment Type",
	edit_title: "Edit Equipment Type: {name}",
	list_title: "List of Equipment Types",
	list_subtitle: "Manage equipment types",
	id: "ID",
	name: "Name",
	status: "Status",
	reference_id: "Reference ID",
	inspection_interval: "Inspection Interval",
};
export default equipmenttypes;